// Globals
import { ReactNode } from 'react';

type TTooltipProps = {
  children?: ReactNode;
  className?: string;
}

export const Tooltip = ({ children, className }: TTooltipProps) => (
  <div className={className}>
    {children}
  </div>
);
